import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const StudentLayout = () => {
  const location = useLocation();
  const isTestPage = location.pathname.endsWith('/test');

  return (
    <div className="d-flex flex-column bg-light" style={{ minHeight: '100dvh' }}>
      {/* Top Navbar */}
      {!isTestPage && (
        <div className="bg-primary-custom p-3 shadow-sm text-center">
          <h4 className="text-white m-0">Assessment Portal</h4>
        </div>
      )}
      
      <div className={`flex-grow-1 overflow-auto d-flex justify-content-center ${!isTestPage ? 'align-items-center' : ''}`}>
        <div className="w-100" style={{ maxWidth: isTestPage ? '100%' : '1200px' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default StudentLayout;
